import React, { useState, useEffect } from 'react';
import '../../assets/MyStyles.scss';

//bootstrap
import Image from 'react-bootstrap/Image';

// MaterialUI
import Box from '@material-ui/core/Box';
import { shadows } from '@material-ui/system';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import { makeStyles } from '@material-ui/core/styles';

// My imports
import logo from '../../assets/images/ib-logo.jpeg';
import DataTable from './DataTable';
import RequestPanel from './RequestPanel';
import { apiUrl } from '../../utils/utils';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: '2rem'
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    height: '100%'
  },
}));



export default function Admin(props) {
  const classes = useStyles();

  const [requests, setRequests] = useState([]);
  const [error, setError] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  // const [checkedRequests, setCheckedRequests] = useState(null)

  var checkedReuests = [];

  useEffect(() => {
    fetch('/admin/api/requests')
      .then(res => res.json())
      .then(
        (result) => {
          setRequests(result)
          setSelectedRequest(result[0]);
        },
        (error) => {
          setError(error)
        }
      )
  }, []);

  const deleteAllRequests = () => {
    fetch('/admin/api/requests', { method: 'DELETE' })
      .then(() => setRequests([]));
  }


  var checkedRequests = ''
  var setCheckedRequests = (data) => {
    checkedRequests = data.rowIds;
  }


  const deleteCheckedRequests = (selected) => {
    fetch('/admin/api/requests', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(checkedRequests)
    });
  }

  const downloadSelectedRequest = () => {
    console.log(selectedRequest)
  }
  



  if (error) {
    return <div>Error: {error.message}</div>;
  } else {
    return (
      <div id='id-admin' className={classes.root}>
        <Grid container justify='center' spacing={2}>
          <Grid item xs={12} md={4}>
            <Image src={logo} rounded className='my-img' />
          </Grid>
          <Grid item align='center' jusify='center' xs={12} md={8}>
            {/* <h1 className='mx-auto my-auto'>Dashboard</h1> */}
          </Grid>
          <Grid item xs={12} md={7}>
            <Paper className={classes.paper} style={{ height: '100%' }}>
              <Container>
                <h2 className='ib-bg p-4'>Incoming traffic</h2>
              </Container>

              <DataTable
                requests={requests}
                setSelectedRequest={setSelectedRequest}
                setCheckedRequests={setCheckedRequests}
              />
              {/* <Box component='span' m={2} p={2}>
                <Button variant="contained" onClick={downloadSelectedRequest} className={classes.button} startIcon={<GetAppIcon />}>
                  Download selected
                </Button>
              </Box> */}
              <Box component='span' m={2} p={2}>
                <Button variant="contained" onClick={deleteAllRequests} color="secondary" className={classes.button} startIcon={<DeleteIcon />}>
                  Delete All
                </Button>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={5}>
            <Paper className={classes.paper}>
              <RequestPanel request={selectedRequest} />
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }

}

